// Libs
import classNames from 'classnames/bind';
import { Grid2, GridSize, Tooltip, Typography } from '@mui/material';
import { ReactNode } from 'react';
// Components, Layouts, Pages
// Others
import { DEFAULT_TOOLTIP_DELAY } from '~/utils/constants/common';
// Styles, images, icons
import styles from './BaseLabelValueField.module.scss';

type Props<T> = {
  label?: string | ReactNode;
  value?: string | ReactNode;
  labelSize?: GridSize;
  bordered?: boolean;
  arrayValue?: T[] | null;
};

const cx = classNames.bind(styles);

const BaseLabelValueField = <T extends { name: string; email: string; phone: string }>(props: Props<T>) => {
  //#region Destructuring Props
  const { label, value, labelSize, arrayValue, bordered = true } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Grid2 component={'div'} container spacing={'8px'} className={cx('container', { bordered: bordered })}>
      <Grid2 size={labelSize || 4}>
        <Tooltip
          title={label}
          placement='top-start'
          enterDelay={DEFAULT_TOOLTIP_DELAY}
          leaveDelay={DEFAULT_TOOLTIP_DELAY}
        >
          <Typography component={'div'} className={cx('text', 'label')}>
            {label}
          </Typography>
        </Tooltip>
      </Grid2>

      {arrayValue && (
        <Grid2 container direction='column' gap={2}>
          {arrayValue.map((item, index) => {
            return (
              <Grid2 size={'grow'} key={index}>
                <Typography component={'div'} className={cx('text', 'value')}>
                  {item.name}, {item.email}, {item.phone}
                </Typography>
              </Grid2>
            );
          })}
        </Grid2>
      )}

      <Grid2 size={'grow'}>
        <Typography component={'div'} className={cx('text', 'value')}>
          {value}
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export default BaseLabelValueField;
